export default __webpack_public_path__ + "static/media/Best-price-guarantee.36731694.svg";